registerComponent("sections/pj-cambio", function (component) {
/**
 * Câmbio PJ — sem comportamento próprio.
 *
 * A entrada escalonada e a pilha `sticky` são do `sections/produtos`.
 */

});
